'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.profile.service
 * @description
 * # profile.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('profileService', function(BaseService, $http, $q, errorService) {

    var service = new BaseService();
    service.getUserProfile = getUserProfile;
    service.updateUserProfile = updateUserProfile;
    service.updateUserProfileUrl = updateUserProfileUrl;


    return service;

    function getUserProfile() {
      return $http.get(service.baseUrl + '/account/userinfo')
        .then(handleSuccess)
        .catch(handleError);
    }

    function updateUserProfileUrl(profile) {
      return service.baseUrl + '/account/userinfo';
    }

    function updateUserProfile(profile) {
      return $http.put(service.baseUrl + '/account/userinfo', profile)
        .then(handleSuccess)
        .catch(handleError);
    }

    function handleSuccess(response) {
      return response.data;
    }

    function handleError(error, status) {
      return service.q.reject(errorService.handleError(error));
    }
  });
